import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './style.scss';

// Register line height attribute
const Parchment = Quill.import('parchment');
const lineHeightConfig = {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['1', '1.15', '1.25', '1.5', '1.75', '2', '2.5', '3']
};
const lineHeightClass = new Parchment.Attributor.Style('lineheight', 'line-height', lineHeightConfig);
Quill.register(lineHeightClass, true);

// Register font size style attributor with a whitelist
const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = ['14px', '8px', '10px', '12px', '16px', '18px'];
Quill.register(SizeStyle, true);

const RichTextEditor = ({
  value = '',
  onChange,
  placeholder = 'Enter text here...',
  disabled = false,
  className = '',
  style = {},
  height = '150px',
  hideToolbar = false,
  enableColor = false,
  enableLineHeight = false,
  enableLists = false,
  error,
  ...props
}) => {
  const handleChange = content => {
    if (onChange) {
      onChange(content);
    }
  };

  const getToolbarConfig = () => {
    if (hideToolbar) return false;

    const baseToolbar = [
      ['bold', 'italic', 'underline'],
      ...(enableLists ? [[{ list: 'ordered' }, { list: 'bullet' }]] : []),
      [{ size: SizeStyle.whitelist }],
      ['link'],
      ['clean']
    ];

    if (enableColor) {
      const toolbar = [
        ['bold', 'italic', 'underline'],
        ...(enableLists ? [[{ list: 'ordered' }, { list: 'bullet' }]] : []),
        [{ size: SizeStyle.whitelist }],
        [{ color: [] }, { background: [] }]
      ];

      // Add line height only if enabled
      if (enableLineHeight) {
        toolbar.push([{ lineheight: ['1', '1.15', '1.25', '1.5', '1.75', '2', '2.5', '3'] }]);
      }
      toolbar.push(['link']);
      toolbar.push(['clean']);
      return toolbar;
    }

    return baseToolbar;
  };

  return (
    <div className={className} style={{ position: 'relative', overflow: 'visible' }}>
      <div style={{ position: 'relative', overflow: 'visible' }}>
        <ReactQuill
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          readOnly={disabled}
          modules={{
            toolbar: getToolbarConfig(),
            // Bootstrap gives <p> a bottom margin. Quill's visual matcher reads that
            // gap as an extra blank line and inserts one on every load/save.
            clipboard: { matchVisual: false }
          }}
          style={{
            height,
            fontSize: '14px',
            ...style
          }}
          {...props}
        />

        {error && (
          <div className="text-danger" style={{ fontSize: '12px', marginTop: '4px' }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default RichTextEditor;
